var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4 8.0001C14.4 9.69748 13.7257 11.3253 12.5255 12.5256C11.3252 13.7258 9.69736 14.4001 7.99998 14.4001C6.30259 14.4001 4.67472 13.7258 3.47449 12.5256C2.27426 11.3253 1.59998 9.69748 1.59998 8.0001C1.59998 6.30271 2.27426 4.67485 3.47449 3.47461C4.67472 2.27438 6.30259 1.6001 7.99998 1.6001C9.69736 1.6001 11.3252 2.27438 12.5255 3.47461C13.7257 4.67485 14.4 6.30271 14.4 8.0001V8.0001ZM8.79998 4.8001C8.79998 5.01227 8.71569 5.21575 8.56566 5.36578C8.41563 5.51581 8.21215 5.6001 7.99998 5.6001C7.7878 5.6001 7.58432 5.51581 7.43429 5.36578C7.28426 5.21575 7.19998 5.01227 7.19998 4.8001C7.19998 4.58792 7.28426 4.38444 7.43429 4.23441C7.58432 4.08438 7.7878 4.0001 7.99998 4.0001C8.21215 4.0001 8.41563 4.08438 8.56566 4.23441C8.71569 4.38444 8.79998 4.58792 8.79998 4.8001ZM7.19998 7.2001C6.9878 7.2001 6.78432 7.28438 6.63429 7.43441C6.48426 7.58444 6.39998 7.78792 6.39998 8.0001C6.39998 8.21227 6.48426 8.41575 6.63429 8.56578C6.78432 8.71581 6.9878 8.8001 7.19998 8.8001V11.2001C7.19998 11.4123 7.28426 11.6158 7.43429 11.7658C7.58432 11.9158 7.7878 12.0001 7.99998 12.0001H8.79998C9.01215 12.0001 9.21563 11.9158 9.36566 11.7658C9.51569 11.6158 9.59998 11.4123 9.59998 11.2001C9.59998 10.9879 9.51569 10.7844 9.36566 10.6344C9.21563 10.4844 9.01215 10.4001 8.79998 10.4001V8.0001C8.79998 7.78792 8.71569 7.58444 8.56566 7.43441C8.41563 7.28438 8.21215 7.2001 7.99998 7.2001H7.19998Z",
    fill: "#7D7D7D"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.218fd77ec9d60b8a233563d96050247b.svg";
export { ForwardRef as ReactComponent };